export enum ReportDataType {
    amount = 1,
    percent
}
